import dayjs from 'dayjs'
import { ContentStrategy } from 'types'

/**
 * A strategy is active if it has no start date, or its start date falls within
 * the next 2 days. The 2-day buffer smooths over the transition window so a
 * strategy launching imminently is treated as already running.
 *
 * Strategies with a start_date beyond today + 2 days are "upcoming".
 */
export const isActiveStrategy = (strategy: ContentStrategy): boolean =>
  !strategy.start_date || dayjs(strategy.start_date).isBefore(dayjs().add(2, 'days'))

export const isUpcomingStrategy = (strategy: ContentStrategy): boolean => !isActiveStrategy(strategy)
